import styled from "@emotion/styled";

export const ListRoot = styled.ul``;
